module.exports = __webpack_public_path__ + "static/Tech Diagram - Single Tenant-b65374437c37b877254e0421f3a2e879.svg";